// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 850px) {
    .scl--cnt-sty-head-box{
        padding-left: var(--global-tablet-padding-left);
        padding-right: var(--global-tablet-padding-left);
        height: 86px;
    }

    .scl--hdd-cont-stl-bo .scl--dd-hea-box-cont-stlr{
        padding-left: var(--global-tablet-padding-left);
        padding-right: var(--global-tablet-padding-left);
    }
    
    .scl--hdd-cont-stl-bo{
        top: 86px;
    }

    .scl--dmhsc-ico-stl-bo{
        width: 46px;
        height: 46px;
    }

    .scl--cnt-sty-head-box .scl--dd-hea-box-cont-stlr ul li button{
        font-size: 20px;
    }
}`, "",{"version":3,"sources":["webpack://./src/layout-module/layout-configuration/header/css/headerSt.css"],"names":[],"mappings":"AAAA;IACI;QACI,+CAA+C;QAC/C,gDAAgD;QAChD,YAAY;IAChB;;IAEA;QACI,+CAA+C;QAC/C,gDAAgD;IACpD;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["@media (max-width: 850px) {\n    .scl--cnt-sty-head-box{\n        padding-left: var(--global-tablet-padding-left);\n        padding-right: var(--global-tablet-padding-left);\n        height: 86px;\n    }\n\n    .scl--hdd-cont-stl-bo .scl--dd-hea-box-cont-stlr{\n        padding-left: var(--global-tablet-padding-left);\n        padding-right: var(--global-tablet-padding-left);\n    }\n    \n    .scl--hdd-cont-stl-bo{\n        top: 86px;\n    }\n\n    .scl--dmhsc-ico-stl-bo{\n        width: 46px;\n        height: 46px;\n    }\n\n    .scl--cnt-sty-head-box .scl--dd-hea-box-cont-stlr ul li button{\n        font-size: 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
